<p-autoComplete 
    #semanticNavigatorComponent
    autofocus="false"
    [(ngModel)]="selectedItem" 
    [group]="true" 
    [suggestions]="filteredGroups()" 
    (completeMethod)="filterGroupedItems($event, semanticNavigatorComponent)" 
    (onFocus)="onFocusTriggered($event, semanticNavigatorComponent)"
    (onSelect)="onItemSelect($event, semanticNavigatorComponent)" 
    placeholder=" Naviga per contenuti...">  


    <ng-template let-item #item>
        <div class="flex items-center gap-2">
              <p-avatar 
                icon="pi {{ item.icon }}" 
                styleClass="icon" 
                [style]="{ 'background-color': item.bgcolor , color: item.color }" />
            <div [title]="item.name ">
                      <div class="name">{{ item.name }}</div>
                      <div class="description">{{ item.description }}</div>  
            </div>
            <p-tag [style]="{ float: 'right' }" [value]="item.chipText" [rounded]="true"  icon="pi pi-angle-right"  /> 
        </div>
    </ng-template> 
    <ng-template let-item #footer>
        <div class="px-3 py-3">
             <p-tag [value]="item.chipText" [rounded]="true"  icon="pi pi-angle-right"  /> 
        </div>
    </ng-template>
 
</p-autoComplete> 